import React, { useState, useEffect } from 'react';
import {  voucherList } from "./addVoucherService";
import { useLocation } from 'react-router-dom';


function useVouchereListHook() {
    const [VoucherListState, setVoucherListState] = useState([]);
    let location = useLocation();


    const fetchVoucherList = async () => {
        try {
            let result = await voucherList(location?.state?.rowData?.ipdid);
            if (result.status === 200) setVoucherListState(result?.data?.result);
        } catch (e) {
            return e
        }

    }
    useEffect(() => {
        fetchVoucherList();
    }, []);

    return {
        VoucherListState,
        

    };
}

export default useVouchereListHook;
